"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedViewsDropdown = void 0;
var React = require("react");
var generic_1 = require("../generic");
var api_1 = require("./api");
function canonicalizeQueryString(queryString) {
    var params = new URLSearchParams(queryString || "");
    params.delete("savedview");
    var entries = [];
    params.forEach(function (value, key) { return entries.push(key + "=" + value); });
    entries.sort();
    return entries.join("&");
}
var SavedViewsDropdown = (function (_super) {
    __extends(SavedViewsDropdown, _super);
    function SavedViewsDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.refresh = function () {
            return _this.api.fetchViews(_this.props.listType).then(function (_a) {
                var views = _a.views, isAdmin = _a.isAdmin;
                _this.setState({ views: views, isAdmin: isAdmin });
            });
        };
        _this.toggleDropdown = function () {
            var opening = !_this.state.isOpen;
            _this.setState({ isOpen: opening, editingId: null, confirmAction: null });
            if (opening) {
                _this.loadViews();
            }
        };
        _this.loadViews = function () {
            _this.setState({ loading: true });
            _this.api.fetchViews(_this.props.listType).then(function (_a) {
                var views = _a.views, isAdmin = _a.isAdmin;
                _this.setState({ views: views, isAdmin: isAdmin, loading: false });
            });
        };
        _this.startEditing = function (view, event) {
            event.stopPropagation();
            _this.setState({ editingId: view.id, editingName: view.name });
        };
        _this.submitRename = function (view) {
            var newName = _this.state.editingName.trim();
            if (newName && newName !== view.name) {
                _this.api.updateView(view.id, { name: newName }).then(function (updated) {
                    _this.setState(function (prev) { return ({
                        views: prev.views.map(function (v) { return v.id === updated.id ? updated : v; }),
                    }); });
                });
            }
            _this.setState({ editingId: null });
        };
        _this.applyView = function (view) {
            _this.api.updateView(view.id, { discardWorking: true }).then(function (updated) {
                _this.props.onApplyView(updated);
                _this.setState(function (prev) { return ({
                    views: prev.views.map(function (v) { return v.id === updated.id ? updated : v; }),
                    isOpen: false,
                    activeViewId: view.id,
                }); });
            });
        };
        _this.handleRenameKeyDown = function (event, view) {
            if (event.key === "Enter") {
                _this.submitRename(view);
            }
            else if (event.key === "Escape") {
                _this.setState({ editingId: null });
            }
        };
        _this.handleSaveNew = function () {
            var name = _this.state.newViewName.trim();
            if (name) {
                _this.api.createView(name, _this.props.listType, window.location.search, _this.state.newViewShared).then(function (newView) {
                    _this.setState(function (prev) { return ({
                        views: __spreadArray(__spreadArray([], __read(prev.views), false), [newView], false),
                        newViewName: "",
                        newViewShared: false,
                    }); });
                });
            }
        };
        _this.requestConfirm = function (viewId, type, event) {
            event.stopPropagation();
            _this.setState({ confirmAction: { viewId: viewId, type: type } });
        };
        _this.cancelConfirm = function (event) {
            event.stopPropagation();
            _this.setState({ confirmAction: null });
        };
        _this.confirmOverwrite = function (view, event) {
            event.stopPropagation();
            _this.api.updateView(view.id, { url: window.location.search }).then(function (updated) {
                _this.setState(function (prev) { return ({
                    views: prev.views.map(function (v) { return v.id === updated.id ? updated : v; }),
                    confirmAction: null,
                }); });
            });
        };
        _this.confirmDelete = function (view, event) {
            event.stopPropagation();
            _this.api.deleteView(view.id).then(function () {
                _this.setState(function (prev) { return ({
                    views: prev.views.filter(function (v) { return v.id !== view.id; }),
                    confirmAction: null,
                    activeViewId: prev.activeViewId === view.id ? null : prev.activeViewId,
                }); });
            });
        };
        _this.state = {
            isOpen: false,
            views: [],
            isAdmin: false,
            editingId: null,
            editingName: "",
            newViewName: "",
            newViewShared: false,
            loading: false,
            activeViewId: null,
            confirmAction: null,
        };
        _this.dropdownRef = React.createRef();
        _this.api = new api_1.SavedViewsApi(props.projectId);
        return _this;
    }
    SavedViewsDropdown.prototype.componentDidMount = function () {
        var _this = this;
        var activeViewId = this.getActiveViewId();
        if (activeViewId) {
            this.setState({ activeViewId: activeViewId });
            this.refresh().then(function () {
                var activeView = _this.getActiveView();
                if (activeView && _this.computeIsModified(activeView)) {
                    _this.applyView(activeView);
                }
            });
        }
    };
    SavedViewsDropdown.prototype.getActiveViewId = function () {
        var params = new URLSearchParams(window.location.search);
        var id = params.get("savedview");
        return id ? parseInt(id, 10) : null;
    };
    SavedViewsDropdown.prototype.getActiveView = function () {
        var _a = this.state, views = _a.views, activeViewId = _a.activeViewId;
        if (activeViewId == null)
            return null;
        return views.find(function (v) { return v.id === activeViewId; }) || null;
    };
    SavedViewsDropdown.prototype.computeIsModified = function (view) {
        return view.isModified
            || canonicalizeQueryString(window.location.search) !== canonicalizeQueryString(view.queryString);
    };
    SavedViewsDropdown.prototype.renderConfirmRow = function (view, type) {
        var _this = this;
        var isOverwrite = type === "overwrite";
        var text;
        if (isOverwrite) {
            text = view.isShared
                ? gettext("Overwrite") + " \"".concat(view.name, "\" ") + gettext("for all users?")
                : gettext("Overwrite") + " \"".concat(view.name, "\" ") + gettext("with current settings?");
        }
        else {
            text = view.isShared
                ? gettext("Delete") + " \"".concat(view.name, "\" ") + gettext("for all users? This can't be undone.")
                : gettext("Delete") + " \"".concat(view.name, "\"? ") + gettext("This can't be undone.");
        }
        return (React.createElement("div", { key: view.id, className: "d-flex flex-column py-2 px-2 border-bottom bg-light" },
            React.createElement("div", { className: "small mb-2 " + (isOverwrite ? "" : "text-danger") }, text),
            React.createElement("div", { className: "d-flex", style: { gap: "0.5rem" } },
                React.createElement("button", { className: "btn btn-sm btn-outline-secondary flex-grow-1", onClick: this.cancelConfirm }, gettext("Cancel")),
                React.createElement("button", { className: "btn btn-sm flex-grow-1 " + (isOverwrite ? "btn-primary" : "btn-danger"), onClick: function (e) { return isOverwrite ? _this.confirmOverwrite(view, e) : _this.confirmDelete(view, e); } }, isOverwrite ? gettext("Overwrite") : gettext("Delete")))));
    };
    SavedViewsDropdown.prototype.renderViewSection = function (title, views, readOnly) {
        var _this = this;
        var _a = this.state, editingId = _a.editingId, editingName = _a.editingName, confirmAction = _a.confirmAction;
        return (React.createElement("div", { className: "mb-3" },
            React.createElement("h6", { className: "text-muted mb-2" }, title),
            views.length > 0 ? (views.map(function (view) {
                if (confirmAction && confirmAction.viewId === view.id) {
                    return _this.renderConfirmRow(view, confirmAction.type);
                }
                return (React.createElement("div", { key: view.id, className: "saved-view-item d-flex align-items-center py-2 border-bottom" }, editingId === view.id ? (React.createElement("input", { type: "text", className: "form-control form-control-sm flex-grow-1", value: editingName, onChange: function (e) { return _this.setState({ editingName: e.target.value }); }, onKeyDown: function (e) { return _this.handleRenameKeyDown(e, view); }, onBlur: function () { return _this.submitRename(view); }, autoFocus: true })) : (React.createElement(React.Fragment, null,
                    React.createElement("a", { className: "flex-grow-1 text-truncate", href: "#", onClick: function (e) {
                            e.preventDefault();
                            _this.applyView(view);
                        }, title: view.name }, view.name),
                    !readOnly && (React.createElement("div", { className: "btn-group btn-group-sm ml-2" },
                        React.createElement("button", { className: "btn btn-sm btn-outline-secondary", title: gettext("Overwrite saved view with current settings."), onClick: function (e) { return _this.requestConfirm(view.id, "overwrite", e); } },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.save })),
                        React.createElement("button", { className: "btn btn-sm btn-outline-secondary", title: gettext("Edit name"), onClick: function (e) { return _this.startEditing(view, e); } },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.edit })),
                        React.createElement("button", { className: "btn btn-sm btn-outline-danger", title: gettext("Delete"), onClick: function (e) { return _this.requestConfirm(view.id, "delete", e); } },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.trash }))))))));
            })) : (React.createElement("p", { className: "text-muted small mb-0" }, gettext("None")))));
    };
    SavedViewsDropdown.prototype.render = function () {
        var _this = this;
        var _a = this.state, views = _a.views, isOpen = _a.isOpen, newViewName = _a.newViewName;
        var activeView = this.getActiveView();
        var isActive = activeView != null;
        var isModified = !!activeView && this.computeIsModified(activeView);
        var toggleClassName = "btn btn-outline-secondary";
        if (isModified) {
            toggleClassName = "btn SavedView--modified";
        }
        else if (isActive) {
            toggleClassName = "btn btn-primary";
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", className: toggleClassName, onClick: this.toggleDropdown },
                React.createElement(generic_1.Icon, { name: generic_1.Icons.star, prefix: isActive ? "fas" : "far" }),
                " ",
                activeView ? activeView.name : gettext("Saved views"),
                isModified && (React.createElement("span", { className: "badge badge-light ml-1" }, gettext("modified")))),
            isOpen && (React.createElement("div", { style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.3)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }, onClick: function (e) {
                    if (e.target === e.currentTarget) {
                        _this.setState({ isOpen: false, editingId: null, confirmAction: null });
                    }
                } },
                React.createElement("div", { className: "card shadow", ref: this.dropdownRef, style: { minWidth: "400px", maxWidth: "500px" } },
                    React.createElement("div", { className: "card-header d-flex justify-content-between align-items-center" },
                        React.createElement("h5", { className: "mb-0" }, gettext("Saved views")),
                        React.createElement("button", { type: "button", className: "close", onClick: function () { return _this.setState({ isOpen: false, editingId: null, confirmAction: null }); } },
                            React.createElement("span", null, "\u00D7"))),
                    React.createElement("div", { className: "card-body", style: { maxHeight: "400px", overflowY: "auto" } },
                        React.createElement("div", { className: "mb-3" }, isActive ? (React.createElement("a", { className: "btn btn-outline-secondary btn-sm btn-block", href: window.location.pathname },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.logout }),
                            " ",
                            gettext("Revert to standard"))) : (React.createElement("button", { type: "button", className: "btn btn-outline-secondary btn-sm btn-block", disabled: true },
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.logout }),
                            " ",
                            gettext("Revert to standard")))),
                        this.renderViewSection(gettext("Shared views"), views.filter(function (v) { return v.isShared; }), !this.state.isAdmin),
                        this.renderViewSection(gettext("My views"), views.filter(function (v) { return !v.isShared; }), false)),
                    React.createElement("div", { className: "card-footer" },
                        React.createElement("div", { className: "d-flex align-items-center" },
                            React.createElement("input", { type: "text", className: "form-control form-control-sm flex-grow-1 mr-2", placeholder: gettext("Save current view as..."), value: newViewName, onChange: function (e) { return _this.setState({ newViewName: e.target.value }); }, onKeyDown: function (e) {
                                    if (e.key === "Enter")
                                        _this.handleSaveNew();
                                } }),
                            this.state.isAdmin && (React.createElement("label", { className: "mb-0 mr-2 text-nowrap", style: { fontSize: "0.85rem" } },
                                React.createElement("input", { type: "checkbox", className: "mr-1", checked: this.state.newViewShared, onChange: function (e) { return _this.setState({ newViewShared: e.target.checked }); } }),
                                gettext("Shared"))),
                            React.createElement("button", { className: "btn btn-sm btn-primary", disabled: !newViewName.trim(), onClick: this.handleSaveNew }, gettext("Save")))))))));
    };
    return SavedViewsDropdown;
}(React.Component));
exports.SavedViewsDropdown = SavedViewsDropdown;
exports.default = SavedViewsDropdown;
